!function() {
  "use strict";
  customElements.get("share-it") || customElements.define("share-it", class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    async share() {
      const shareData = {
        text: this.el?.getAttribute("title") || this.el?.textContent || document.title,
        url: this.el?.getAttribute("href") || location.href
      };
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log("Error: " + err);
      }
    }
    init() {
      this.el = this.querySelector("a"), (this.el || this).addEventListener("click", (event => {
        event.preventDefault(), this.share();
      }));
    }
  });
}();